import React from 'react';
import { Outlet } from 'react-router-dom';
import { KeycloakRoute, REALM_INTERN } from '@europrocurement/l2d-keycloak';

const DocumentTypeRoot: React.FunctionComponent = function () {
    return (
        <KeycloakRoute roles={REALM_INTERN}>
            <Outlet />
        </KeycloakRoute>
    );
};

export default DocumentTypeRoot;
